module.exports = __webpack_public_path__ + "04_very_short_grey.ae27fb50.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_very_short_grey.png
// module id = dCXs
// module chunks = 0